// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__3sikZ","actions":"GroupTable_actions__3Jf03","deleteModalFooter":"GroupTable_deleteModalFooter__Ejowa"};